"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bike_enDe = void 0;
exports.bike_enDe = {
    metaData: {
        prismicId: 'Zp4OQhMAAC4AqEoK',
        type: 'comparisontable',
        uid: 'bike',
        lang: 'en-de',
        lastPublished: '2024-08-05T13:23:27+0000',
    },
    tableData: {
        title: 'Bike',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$beaa4f8a-f61b-434d-af6f-bb8056a648b0_header',
                            text: 'Our plans',
                            description: null,
                        },
                        {
                            cellId: 'table_row$beaa4f8a-f61b-434d-af6f-bb8056a648b0_0',
                            type: 'BUTTON',
                            buttonCaption: 'Basic',
                            disabled: true,
                        },
                        {
                            cellId: 'table_row$beaa4f8a-f61b-434d-af6f-bb8056a648b0_1',
                            type: 'BUTTON',
                            buttonCaption: 'Comfort',
                            disabled: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4ecdad64-d4ac-44fd-b9f0-3a30c9e2daf5_header',
                            text: 'Theft',
                            description: 'The policy covers loss of your bike/e-bike through theft, robbery, and burglary.',
                        },
                        {
                            cellId: 'table_row$4ecdad64-d4ac-44fd-b9f0-3a30c9e2daf5_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$4ecdad64-d4ac-44fd-b9f0-3a30c9e2daf5_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$f396a213-37eb-4a2b-b64c-fec79e98dd30_header',
                            text: 'Parts theft',
                            description: 'The theft of parts essential to its function is covered. Additional accessories (E,g. lock) are also covered if stolen along with the rest of the bike.',
                        },
                        {
                            cellId: 'table_row$f396a213-37eb-4a2b-b64c-fec79e98dd30_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$f396a213-37eb-4a2b-b64c-fec79e98dd30_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b27e70ca-b24d-436e-a273-bd8c36792493_header',
                            text: 'Vandalism',
                            description: 'The insurance covers damage and destruction by unknown third parties.',
                        },
                        {
                            cellId: 'table_row$b27e70ca-b24d-436e-a273-bd8c36792493_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$b27e70ca-b24d-436e-a273-bd8c36792493_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e8c7cdb0-d9e5-4251-aebd-a1a3d0d7ff18_header',
                            text: 'Damage',
                            description: 'Costs of repairs resulting from accidents, falls, production errors, electronic damage and some others will be reimbursed.',
                        },
                        {
                            cellId: 'table_row$e8c7cdb0-d9e5-4251-aebd-a1a3d0d7ff18_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$e8c7cdb0-d9e5-4251-aebd-a1a3d0d7ff18_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$efa1ea8d-6151-40e5-b155-184a8679d77d_header',
                            text: 'Wear',
                            description: 'Damage due to wear and tear on the bike is insured, including brakes and tires. Even rechargeable batteries, if the performance capacity is permanently undercut by 50%.',
                        },
                        {
                            cellId: 'table_row$efa1ea8d-6151-40e5-b155-184a8679d77d_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$efa1ea8d-6151-40e5-b155-184a8679d77d_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$eefb095a-4a50-4e62-866c-1ce9e52d2991_header',
                            text: 'Battery protection',
                            description: 'When you insure an e-bike, the battery is insured against theft, in addition to damage, electronic damage and wear and tear in the premium cover.',
                        },
                        {
                            cellId: 'table_row$eefb095a-4a50-4e62-866c-1ce9e52d2991_0',
                            text: 'Only theft',
                        },
                        {
                            cellId: 'table_row$eefb095a-4a50-4e62-866c-1ce9e52d2991_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
        ],
    },
};
